<template>
  <Role />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import Role from '@/app/features/admin/roles/Role.vue';

  export default defineComponent({
    name: 'RolePage',
    components: {
      Role,
    },
  });
</script>

